import { VIANUVEM_API_ENDPOINT } from './Defaults';
import { getVnSecret } from '../utility/utils';

let headers = {
  'Accept': 'application/json',
  'Content-Type': 'application/json'
}

class InvitesAPI {

  static sendInvites = invites =>
    new Promise((resolve, reject) => {
      headers.vnSecret = getVnSecret();
      fetch(`${VIANUVEM_API_ENDPOINT}/api/collaboration/invites/bulk`, {
        method: 'POST',
        body: JSON.stringify(invites),
        headers
      })
      .then(res => {
        if (res.ok) {
          resolve();
        }
        else {
          res.json()
            .then(reject)
            .catch(() => reject())
        }
      })
      .catch(reject);
    });

}

export default InvitesAPI;



// WEBPACK FOOTER //
// ./src/integrations/InvitesAPI.js